import { useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';
import { useCallback } from 'react';

import { CachedBonuses } from '../../../../../../types/bonus';
import { updateCachedReactions } from '../../../cache/mutators/bonus';
import { useFindBonus } from '../../../components/reactions/hooks/use-find-bonus';
import { QueryKey } from '../../../hooks/types';
import { Reaction } from '../../../types/reaction';

export const useRemoveReactionFromBonus = () => {
	const queryClient = useQueryClient();
	const findBonus = useFindBonus();

	return useCallback(
		(id: string, reactionId: string) => {
			const bonus = findBonus(id);

			if (!bonus) {
				return;
			}

			let found: Reaction | undefined;
			const newReactions = produce(bonus.reactions ?? [], (draft) => {
				const index = draft.findIndex((reaction) => reaction._id === reactionId);
				if (index !== -1) {
					found = draft[index];
					draft.splice(index, 1);
				}
			});

			queryClient.setQueriesData<CachedBonuses>([QueryKey.BonusesInfinite], (cached) => updateCachedReactions(id, newReactions, cached));

			return found;
		},
		[findBonus, queryClient]
	);
};
